import { BoundingBox } from '@bpd-library/types';

export const fitBounds = (map: mapboxgl.Map, boundingBox: BoundingBox) =>
    map.fitBounds(boundingBox);
